
import { defineComponent } from 'vue'
import Heading from '@/components/Heading.vue'
import StartLoanButton from '@/components/StartLoanButton.vue'

export default defineComponent({
  components: {
    Heading,
    StartLoanButton
  },

  emits: ['newLoan']
})
